import { ICON_TYPE, IconPropsModel } from "./Icon.model";
import CloseIcon from "./icons/CloseIcon";
import InstagramIcon from "./icons/InstagramIcon";
import LinkedinIcon from "./icons/LinkedinIcon";
import PrevIcon from "./icons/PrevIcon";

export default function Icon({
  type,
  size = 24,
  fill,
  stroke,
  className,
  ...props
}: IconPropsModel) {
  const renderIcon = () => {
    switch (type) {
      case ICON_TYPE.INSTAGRAM:
        return (
          <InstagramIcon
            size={size}
            fill={fill}
            stroke={stroke}
            className={className}
            {...props}
          />
        );

      case ICON_TYPE.LINKEDIN:
        return (
          <LinkedinIcon
            size={size}
            fill={fill}
            stroke={stroke}
            className={className}
            {...props}
          />
        );

      case ICON_TYPE.PREV:
        return (
          <PrevIcon
            size={size}
            fill={fill}
            stroke={stroke}
            className={className}
            {...props}
          />
        );

      case ICON_TYPE.CLOSE:
        return (
          <CloseIcon
            size={size}
            fill={fill}
            stroke={stroke}
            className={className}
            {...props}
          />
        );

      default:
        return null;
    }
  };

  return renderIcon();
}
